module.exports = __webpack_public_path__ + "static/media/SV.60f2b251.png";